module.exports = __webpack_public_path__ + "media/images/round_green_check-83800b1d.png";